// extracted by mini-css-extract-plugin
module.exports = {"root-item":"root-item___2XXTS","has-sidebar":"has-sidebar___23pTf"};